import axios from 'axios';

import { API } from '@/config/constants';


const requestConfig = (contentType, { token, onUploadProgress } = {}) => {
  const headers = { 'Content-Type': contentType };
  if (token) headers.Authorization = `Bearer ${token}`;

  return {
    headers,
    ...(onUploadProgress ? { onUploadProgress } : {}),
  };
};


export const getDeliveryLog = async (params = {}, config) => {
  const response = await axios.get(`${API}/delivery-log`, { ...config, params });
  return response.data;
};

export const getOrderDeliveryConfirmation = async (orderId, { token, signal } = {}) => {
  const response = await axios.get(`${API}/orders/${orderId}/delivery-confirmation`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    ...(signal ? { signal } : {}),
  });
  return response.data;
};

export const getOrderDeliveryAttempt = async (orderId, captureId, { token, signal } = {}) => {
  const response = await axios.get(`${API}/orders/${encodeURIComponent(orderId)}/delivery-attempts/${encodeURIComponent(captureId)}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    ...(signal ? { signal } : {}),
    timeout: 15000,
  });
  return response.data;
};

export const getOrderDeliveryAmendment = async (orderId, captureId, { token, signal } = {}) => {
  const response = await axios.get(`${API}/orders/${encodeURIComponent(orderId)}/delivery-amendments/${encodeURIComponent(captureId)}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    ...(signal ? { signal } : {}),
    timeout: 15000,
  });
  return response.data;
};

export const getOrderDeliveryFailure = async (orderId, captureId, { token, signal } = {}) => {
  const response = await axios.get(`${API}/orders/${encodeURIComponent(orderId)}/delivery-failures/${encodeURIComponent(captureId)}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    ...(signal ? { signal } : {}), timeout: 15000,
  });
  return response.data;
};

export const getSavedDeliveryLabel = async (orderId, { token, signal } = {}) => {
  const response = await axios.get(`${API}/orders/${encodeURIComponent(orderId)}/saved-delivery-label`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    ...(signal ? { signal } : {}),
    timeout: 15000,
  });
  return response.data;
};

export const getDeliveryMediaBlob = async (storagePath, { token, signal } = {}) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const response = await axios.get(
    `${API}/delivery-media/${encodeURIComponent(storagePath)}`,
    { headers, responseType: 'blob', ...(signal ? { signal } : {}) },
  );
  return response.data;
};

export const updateOrderDelivery = async (orderId, data, options) => {
  const response = await axios.put(
    `${API}/orders/${orderId}/update-delivery`,
    data,
    requestConfig('application/json', options),
  );
  return response.data;
};

export const confirmOrderDelivery = async (orderId, formData, options) => {
  const response = await axios.post(
    `${API}/orders/${orderId}/confirm-delivery`,
    formData,
    requestConfig('multipart/form-data', options),
  );
  return response.data;
};

export const uploadOrderDeliveryMedia = async (orderId, formData, options) => {
  const response = await axios.post(
    `${API}/orders/${orderId}/add-delivery-media`,
    formData,
    requestConfig('multipart/form-data', options),
  );
  return response.data;
};

export const addOrderDeliveryMedia = async (orderId, files, options) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('photos', file));
  return uploadOrderDeliveryMedia(orderId, formData, options);
};

export const failOrderDelivery = async (orderId, data, options) => {
  const response = await axios.post(
    `${API}/orders/${orderId}/fail-delivery`,
    data,
    { ...requestConfig('application/json', options), ...(data.failure_id ? { timeout: 15000 } : {}) },
  );
  return response.data;
};
